// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 283 ? "fe680085" : chunkId) + "." + {"283":"01d9f9f69032a1cf","686":"e6b8cd80b64abc9e"}[chunkId] + ".js";
};